// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MN9J6","logo":"styles_logo__WISeh"};